module.exports = __webpack_public_path__ + "static/media/s_bar9.a3e4ef53.svg";